import React, { createContext, useContext, useState } from 'react';

const ChatCacheContext = createContext();

export const useChatCache = () => {
  const context = useContext(ChatCacheContext);
  if (!context) {
    throw new Error('useChatCache must be used within a ChatCacheProvider');
  }
  return context;
};

export const ChatCacheProvider = ({ children }) => {
  // Store conversations with their messages pre-loaded
  const [cachedConversations, setCachedConversations] = useState({});

  const cacheConversation = (conversationId, data) => {
    setCachedConversations(prev => ({
      ...prev,
      [conversationId]: {
        ...data,
        cachedAt: new Date().toISOString(),
      }
    }));
  };

  const getCachedConversation = (conversationId) => {
    return cachedConversations[conversationId] || null;
  };

  const clearCache = () => {
    setCachedConversations({});
  };

  const value = {
    cacheConversation,
    getCachedConversation,
    clearCache,
  };

  return (
    <ChatCacheContext.Provider value={value}>
      {children}
    </ChatCacheContext.Provider>
  );
};

